import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../admin/api";
import PageHero from "../Components/PageHero";
import { Helmet } from "react-helmet-async";
import { Whatsapp, Facebook } from "react-bootstrap-icons";

function BlogDetails() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetchBlog();
  }, [slug]);

  const fetchBlog = async () => {
    try {
      const res = await api.get(`/UiplusBlogs/${slug}`);
      setBlog(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const cleanContent = (html) => {
    if (!html) return "";
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    let decoded = txt.value;

    decoded = decoded.replace(/<span[^>]*>/g, "");
    decoded = decoded.replace(/<\/span>/g, "");
    decoded = decoded.replace(/&lt;/g, "<").replace(/&gt;/g, ">");

    return decoded;
  };

  if (!blog) return <p className="text-center mt-5">Loading...</p>;

  const currentUrl = window.location.href;

  const whatsappShare = `https://wa.me/?text=${encodeURIComponent(
    blog.title + " " + currentUrl
  )}`;

  const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    currentUrl
  )}`;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <title>{blog.title}</title>
        <meta property="og:title" content={blog.title} />
        <meta
          property="og:description"
          content={blog.content?.substring(0, 150)}
        />
        <meta property="og:image" content={blog.imageUrl} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:type" content="article" />
      </Helmet>

      <PageHero title="Blog Details" subtitle={blog.title} />

      <div className="container mt-5 mb-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">

            {/* 🔥 Blog Card */}
            <div className="card shadow-lg border-0 blog-detail-card">

              {/* 🔹 Blog Image */}
              {blog.imageUrl && (
                <img
                  src={blog.imageUrl}
                  alt={blog.title}
                  className="card-img-top blog-image"
                />
              )}

              <div className="card-body p-4">

                {/* Title */}
                <h1 className="fw-bold mb-3">{blog.title}</h1>

                {/* Meta */}
                <div className="text-muted mb-3">
                  📅 {formatDate(blog.createdDate)} &nbsp; | &nbsp; ✍️ Admin
                </div>

                {/* Share Buttons */}
                <div className="d-flex gap-3 mb-4">
                  <a
                    href={whatsappShare}
                    target="_blank"
                    className="btn btn-success d-flex align-items-center gap-2"
                  >
                    <Whatsapp size={18} /> WhatsApp
                  </a>

                  <a
                    href={facebookShare}
                    target="_blank"
                    className="btn btn-primary d-flex align-items-center gap-2"
                  >
                    <Facebook size={18} /> Facebook
                  </a>
                </div>

                {/* Content */}
                <div
                  className="blog-content"
                  dangerouslySetInnerHTML={{
                    __html: cleanContent(blog.content),
                  }}
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* 🔥 Modern CSS */}
      <style>{`
        .blog-detail-card {
          border-radius: 12px;
          overflow: hidden;
        }

        .blog-image {
  width: 100%;
  max-height: 400px;
  object-fit: cover;
}

@media (max-width: 768px) {
  .blog-image {
    height: auto;
    object-fit: contain;
  }
}

        .blog-content p {
          font-size: 17px;
          line-height: 1.7;
          margin-bottom: 12px;
        }

        .blog-content h2, .blog-content h3 {
          margin-top: 20px;
          font-weight: bold;
        }

        .blog-content ul {
          padding-left: 20px;
        }

        .blog-content li {
          margin-bottom: 6px;
        }
      `}</style>
    </>
  );
}

export default BlogDetails;